
export default function CategorySection() {
  return null;
}
